import { render, staticRenderFns } from "./protocolInfo.vue?vue&type=template&id=390de1fc&scoped=true"
import script from "./protocolInfo.vue?vue&type=script&lang=js"
export * from "./protocolInfo.vue?vue&type=script&lang=js"
import style0 from "./protocolInfo.vue?vue&type=style&index=0&id=390de1fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390de1fc",
  null
  
)

export default component.exports